import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { AnyConnection } from '../connection.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class ConnectionsResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(connection_id: number, params?: QueryParams): Observable<AnyConnection> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<AnyConnection>(`${this.apiRoot}/${account_id}/api/connections/${connection_id}`, { params }),
      ),
    );
  }

  save(body: Partial<AnyConnection>, params?: QueryParams): Observable<AnyConnection> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<AnyConnection>(`${this.apiRoot}/${account_id}/api/connections`, body, { params }),
      ),
    );
  }

  update(connection_id: number, body: Partial<AnyConnection>, params?: QueryParams): Observable<AnyConnection> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<AnyConnection>(`${this.apiRoot}/${account_id}/api/connections/${connection_id}`, body, {
          params,
        }),
      ),
    );
  }

  remove(connection_id: number, params?: QueryParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<AnyConnection>(`${this.apiRoot}/${account_id}/api/connections/${connection_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<AnyConnection[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<AnyConnection[]>(`${this.apiRoot}/${account_id}/api/connections`, { params }),
      ),
    );
  }

  search(params?: QueryParams): Observable<AnyConnection[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<AnyConnection[]>(`${this.apiRoot}/${account_id}/api/connections/search`, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Connection', downgradeInjectable(ConnectionsResource));
